"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/dialog/dist/mdc.dialog.css");
require("@rmwc/button/styles");
require("@rmwc/ripple/styles");
